import { useEffect, useState } from 'react';
import apiClient from '../api/client';

export function useAuthenticatedFileUrl(url?: string, expectedMime?: string) {
  const [resolvedUrl, setResolvedUrl] = useState('');

  useEffect(() => {
    if (!url || url.startsWith('blob:')) {
      setResolvedUrl('');
      return;
    }
    if (!url.includes('/api/files/')) {
      setResolvedUrl(url);
      return;
    }

    let objectUrl = '';
    let cancelled = false;
    apiClient.get(url, { responseType: 'blob' }).then((response) => {
      if (cancelled) return;
      const contentType = response.headers['content-type'] || response.data.type || '';
      if (contentType.includes('json') || (expectedMime && !contentType.startsWith(expectedMime))) {
        throw new Error('Arquivo retornado com tipo inválido');
      }
      objectUrl = URL.createObjectURL(response.data);
      setResolvedUrl(objectUrl);
    }).catch(() => {
      if (!cancelled) setResolvedUrl('');
    });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url, expectedMime]);

  return resolvedUrl;
}
